export default __webpack_public_path__ + "static/media/about-thumb-3-challenge.17efa608.webp";